import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/deployment";
import { createAction } from "redux-act";
// Action to increment deployment counter after deployment completes
export const incrementDeploymentCounter = createAction("INCREMENT_DEPLOYMENT_COUNTER", (gameId) => ({ gameId }));
export const deploymentReducer = {
    reducers: {
        [actions.setDeploymentNecessary]: (state, payload) => setSafe(state, ["needToDeploy", payload.gameId], payload.required),
        [incrementDeploymentCounter]: (state, payload) => {
            const current = state.deploymentCounter?.[payload.gameId] || 0;
            return setSafe(state, ["deploymentCounter", payload.gameId], current + 1);
        },
    },
    defaults: {
        needToDeploy: {},
        deploymentCounter: {},
    },
};
